import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturesStrip from './components/FeaturesStrip';
import AboutPreview from './components/AboutPreview';
import ServicesPreview from './components/ServicesPreview';
import Testimonials from './components/Testimonials';
import CTABanner from './components/CTABanner';

export default function HomePage() {
  return (
    <div className="min-h-screen font-sans">
      <Navbar />
      <main>
        <HeroSection />
        <FeaturesStrip />
        <AboutPreview />
        <ServicesPreview />
        <Testimonials />
        <CTABanner />
      </main>
      <Footer />
    </div>
  );
}
